import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import { addHours, format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Link } from "react-router-dom";
import { MdCalendarToday } from "react-icons/md";

const EventCard = ({ event }) => {
  const speakersOpen =
    new Date(event.eventStartSubscriptionForSpeakers) <= new Date() &&
    new Date(
      new Date(event.eventEndSubscriptionForSpeakers).setHours(
        new Date(event.eventEndSubscriptionForSpeakers).getHours() + 27
      )
    ) >= new Date();

  const listenersOpen =
    new Date(event.eventStartSubscriptionForListeners) <= new Date() &&
    new Date(
      new Date(event.eventEndSubscriptionForListeners).setHours(
        new Date(event.eventEndSubscriptionForListeners).getHours() + 27
      )
    ) >= new Date();

  return (
    <Box
      borderRadius="1.25rem"
      overflow="hidden"
      bg="white"
      boxShadow="0 2px 12px rgba(0,0,0,0.08)"
      border="1px solid"
      borderColor="gray.100"
      _hover={{ boxShadow: "0 8px 32px rgba(0,0,0,0.14)", transform: "translateY(-4px)" }}
      transition="all 0.25s"
      display="flex"
      flexDir="column"
      maxW="380px"
    >
      <Link to={`./${event.eventId}`}>
        <Box overflow="hidden" h="200px">
          <Image
            src={`${process.env.REACT_APP_S3_BASEURL}/events_images/${event.image}`}
            w="100%"
            h="100%"
            objectFit="cover"
            _hover={{ transform: "scale(1.04)" }}
            transition="transform 0.3s"
          />
        </Box>
      </Link>

      <Flex flexDir="column" flex={1} p={5} gap={2}>
        <Heading size="sm" noOfLines={2} color="gray.800">
          {event.name}
        </Heading>
        <Text fontSize="0.85rem" color="gray.500" fontStyle="italic" noOfLines={1}>
          Tema: {event.theme}
        </Text>
        <Flex alignItems="center" gap={2} color="green.600" fontSize="0.9rem" mt={1}>
          <Box as={MdCalendarToday} />
          <Text>
            {format(
              new Date(addHours(new Date(event?.eventDate), 3)),
              "dd 'de' MMMM 'de' yyyy",
              { locale: ptBR }
            )}
          </Text>
        </Flex>

        {(speakersOpen || listenersOpen) && (
          <Flex gap={2} wrap="wrap" mt={1}>
            {speakersOpen && (
              <Badge colorScheme="green" fontSize="0.7rem">
                Inscrições abertas para palestrantes
              </Badge>
            )}
            {listenersOpen && (
              <Badge colorScheme="teal" fontSize="0.7rem">
                Inscrições abertas para ouvintes
              </Badge>
            )}
          </Flex>
        )}

        <Flex justifyContent="flex-end" mt="auto" pt={3}>
          <Link to={`./${event.eventId}`}>
            <Button size="sm" colorScheme="green">
              Mais Informações
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
};

export default EventCard;
